import type { ChatSuggestion } from "../types";

/**
 * All that is left of the stub. Asking, history, pinning, renaming, deleting
 * and search are live against helena-ask-service; these are the empty-state
 * chips, which stay hardcoded until `GET /api/v1/capabilities` is wired and can
 * supply them from the service's own tool registry. The queue counts are live
 * and come from `useOverviewCounts`.
 */
export const MOCK_SUGGESTIONS: ChatSuggestion[] = [
  {
    id: "create-ticket",
    label: "Create ticket",
    icon: "ticket",
    prompt: "Create a ticket",
    analyticsType: "create_ticket",
  },
  // {
  //   id: "create-customer",
  //   label: "Create customer",
  //   icon: "customer",
  //   prompt: "Create a customer",
  //   analyticsType: "create_customer",
  // },
  // {
  //   id: "create-user",
  //   label: "Create user",
  //   icon: "user",
  //   prompt: "Create a user",
  //   analyticsType: "create_user",
  // },
  {
    id: "critical-high-priority-tickets",
    label: "List my open critical and high-priority tickets",
    icon: "chart",
    prompt: "List my open critical and high-priority tickets",
    analyticsType: "critical_high_priority_tickets",
  },
  {
    id: "my-workload",
    label: "What's my workload this week?",
    icon: "chart",
    prompt: "What's my workload this week?",
    analyticsType: "my-workload",
  },
];
